import { motion } from "framer-motion";
import { ASSETS } from "@/data/content";
import Reveal from "@/components/arc/Reveal";

const PageHero = ({ index, eyebrow, title, sub, image = ASSETS.background, position = "center 30%" }) => (
  <section className="scanlines relative overflow-hidden pb-16 pt-36 md:pb-24 md:pt-48">
    <div className="absolute inset-0" aria-hidden="true">
      <img
        src={image}
        alt=""
        className="h-full w-full object-cover opacity-40"
        style={{ objectPosition: position }}
        loading="eager"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-abyss/80 via-space/70 to-abyss" />
      <div className="grid-overlay absolute inset-0 opacity-40" />
      <div className="absolute inset-x-0 top-1/3 h-px animate-scan bg-gradient-to-r from-transparent via-electric/50 to-transparent" />
    </div>
    <div className="relative mx-auto max-w-[1600px] px-5 md:px-8">
      <Reveal>
        <p className="font-term text-[11px] tracking-[0.4em] text-electric" data-testid="page-hero-index">
          {index} {"//"} {eyebrow}
        </p>
      </Reveal>
      <div className="overflow-hidden">
        <motion.h1
          initial={{ y: "110%" }}
          animate={{ y: 0 }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1], delay: 0.1 }}
          className="mt-5 font-display text-4xl font-black tracking-[0.06em] text-chrome text-glow-blue sm:text-5xl lg:text-7xl"
          data-testid="page-hero-title"
        >
          {title}
        </motion.h1>
      </div>
      {sub && (
        <Reveal delay={0.25}>
          <p className="mt-6 max-w-2xl text-base leading-relaxed text-silver md:text-lg">{sub}</p>
        </Reveal>
      )}
      <Reveal delay={0.35}>
        <div className="glow-line mt-10 w-48" />
      </Reveal>
    </div>
  </section>
);

export default PageHero;
